import type { BaseRoute } from "@/routes/routes.mjs";
import lazyFn from "@/util/lazy-fn.mjs";
import pathRegExp from "@/util/path-regexp.mjs";

const csgoFetchProfileData = lazyFn(
  () => import("@/game-csgo/fetches/profile-page.mjs"),
);

const csgoFetchMatchData = lazyFn(
  () => import("@/game-csgo/csgo-fetch-match-data.mjs"),
);

const fetchMapsStats = lazyFn(
  () => import("@/game-cs2-marketing/fetch-cs2-map-stats.mjs"),
);

const fetchWeaponsStats = lazyFn(
  () => import("@/game-cs2-marketing/fetch-cs2-weapon-stats.mjs"),
);

const fetchStatsData = lazyFn(
  () => import("@/game-csgo/csgo-fetch-stats-data.mjs"),
);

const fetchLeaderboard = lazyFn(
  () => import("@/game-csgo/fetches/fetch-leaderboard.mjs"),
);

const fetchMapLineups = lazyFn(
  () => import("@/game-csgo/fetches/fetch-map-lineups.mjs"),
);

const fetchArticle = lazyFn(
  () => import("@/shared/fetch-contentful-article.mjs"),
);

const routes = [
  {
    path: pathRegExp("/csgo{/:path}*"),
    redirect({ parameters: [path] }) {
      return path ? `/cs2/${path}` : `/cs2`;
    },
  },
  {
    path: pathRegExp("/cs2/profile/:profileId{/:tab}?"),
    component: "game-csgo/Profile.tsx",
    fetchData: csgoFetchProfileData,
    key: "cs2-profile",
  },
  {
    // pls dont use this old route, it was set up by someone who
    // just randomly made a path without looking at existing games
    path: pathRegExp("/cs2/profile/:profileId/match/:matchId{/:tab}?"),
    redirect: ({ parameters: [profileId, matchId, tab] }) =>
      `/cs2/match/${profileId}/${matchId}${tab ? `/${tab}` : ""}`,
  },
  {
    path: pathRegExp("/cs2/match/:profileId/:matchId{/:tab}?"),
    component: "game-csgo/Match.tsx",
    fetchData: csgoFetchMatchData,
  },
  {
    path: "/cs2/in-game",
    component: "game-csgo/Match.tsx",
    fetchData: csgoFetchMatchData,
  },

  // Leaderboard
  {
    path: "/cs2/leaderboard",
    component: "game-cs2-marketing/Leaderboard.tsx",
    fetchData: fetchLeaderboard,
  },

  // Statistics
  {
    path: "/cs2/statistics",
    redirect: "/cs2/stats",
  },
  {
    path: "/cs2/stats",
    redirect: "/cs2/stats/maps",
  },
  {
    path: "/cs2/statistics/maps",
    redirect: "/cs2/stats/maps",
  },
  {
    path: "/cs2/statistics/weapons",
    redirect: "/cs2/stats/weapons",
  },
  {
    path: pathRegExp("/cs2/stats/(maps|weapons)"),
    component: "game-cs2-marketing/Stats.tsx",
    fetchData: fetchStatsData,
  },

  // Marketplace
  {
    path: "/cs2/marketplace",
    component: "game-cs2-marketing/Marketplace.tsx",
  },

  // Database
  {
    path: "/cs2/database",
    redirect: "/cs2/database/weapons",
  },
  {
    path: "/cs2/database/maps",
    component: "game-cs2-marketing/DatabaseMaps.tsx",
  },
  {
    path: pathRegExp("/cs2/database/maps/:map/(overview)"),
    component: "game-cs2-marketing/DatabaseMap.tsx",
    fetchData: fetchMapsStats,
  },
  {
    path: "/cs2/database/weapons",
    component: "game-cs2-marketing/DatabaseWeapons.tsx",
  },
  {
    path: pathRegExp("/cs2/database/weapons/:weapon/(overview)"),
    component: "game-cs2-marketing/DatabaseWeapon.tsx",
    fetchData: fetchWeaponsStats,
  },
  {
    path: "/cs2/console-commands",
    component: "game-cs2-marketing/ConsoleCommands.tsx",
  },
  {
    path: pathRegExp("/cs2/lineups"),
    component: "game-csgo/GrenadeLineups.tsx",
    fetchData: fetchMapLineups,
  },
  {
    path: pathRegExp("/cs2/article/:id"),
    component: "game-csgo/Article.tsx",
    fetchData: fetchArticle,
  },
] as BaseRoute[];

export default routes;
